import { createSlice } from '@reduxjs/toolkit'
import { registerUser, updateRole, getUserDetails, isRegisteredInPlatform } from '../Services/Login/LoginService';
import { apiEndpoints } from '../Configurations/Constants';
import { isExists, forgetSignupRole } from '../Helpers/Utils';
const slice = createSlice({
    name: 'user',
    initialState: {
        user: null
    },
    reducers: {
        updateProfileImg: (state, action) => {
            state.user.profileImage = action.payload;
        },
        setUserDetails: (state, action) => {
            state.user = action.payload;
        }
    },
});

export default slice.reducer;
// Actions
const { updateProfileImg, setUserDetails } = slice.actions
// Applies the role, then loads the resulting profile. Shared tail of both paths.
const applyRoleAndLoadUser = async (dispatch, account, role) => {
    await updateRole(apiEndpoints.Account.SignIn, account, role);
    const user = await getUserDetails(account.username);
    if (user) {
        dispatch(setUserDetails(user));
    }
    return true;
}

export const register = (account, role) => async dispatch => {
    // Ask before posting. newUser says B2C created a directory account, not that
    // the platform lacks a row for the address, and the two come apart once a
    // directory account is deleted while its row survives. Posting sign-up then
    // is destructive: the API rolls back by deleting the account behind that
    // e-mail, which is the one that just signed in.
    // Errors are not caught here on purpose. Either guess is harmful, so report.
    const alreadyRegistered = await isRegisteredInPlatform(account.username);

    if (!alreadyRegistered) {
        await registerUser(apiEndpoints.Account.RegisterUser, account, role);
    }

    // Done with the remembered role; a later generic-door visit would reuse it.
    forgetSignupRole();

    return applyRoleAndLoadUser(dispatch, account, role);
}

export const registerRole = (account, role) => async dispatch => {
    // Written on every /register-as-* load, and this path is the only one that
    // clears it on a repeat visit, since newUser is a one-shot claim.
    forgetSignupRole();

    return applyRoleAndLoadUser(dispatch, account, role);
}

export const getUserInfo = (email) => async dispatch => {
    return new Promise((resolve, reject) => {
        try {
            getUserDetails(email)
                .then((res) => {
                    dispatch(setUserDetails(res));
                    resolve(true);
                })
                .catch(
                    error => {
                        reject(error);
                    }
                )
        }
        catch (error) {
            reject(error);
        }
    });
}
export const updateUserDetails = (userDetails) => async dispatch => {
    if (isExists(userDetails)) {
        dispatch(setUserDetails(userDetails));
    }
}
export const updateProfileImgPath = (imgUrl) => async dispatch => {
    dispatch(updateProfileImg(imgUrl));
}
